import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import Chart from 'chart.js';
import DashboardLayout from '../layout/Dashboard';
import { ChartHeaders } from '../../components/shared/charts/layout/ChartHeaders';
import { FinancialBar } from '../../components/shared/charts/financial/FinancialBarChart';
import { QualitativeLine } from '../../components/shared/charts/financial/QualitativeLineChart';
import { Messages } from '../../components/layout/Messages/Messages';
import { NoRights } from '../../components/layout/Permissions/NoRights';
import {
  PageHeader,
  PageSurface,
  PageWorkspace
} from '../../components/layout/Workspace';
import { getInfoCardsData } from '../../api/admin/reports';
import { ACL } from '../../config/constants/UogACL/ACL';
import { chartExample3 } from './examples/ChartExample3';
import { chartExample2 } from './examples/ChartExample2';
import { chartOptions, parseOptions } from './examples/chartOptions';
import { store } from '../../store/store';
import { hideNotification } from '../../store/actions/notification';

const GeneralReports = props => {
  if (window.Chart) {
    parseOptions(Chart, chartOptions());
  }

  const hasAccess = ACL.CLIENT.REPORTS.LIST.hasAccess();
  const { hideSpinner } = props;
  const [expandChart, setExpandChart] = useState('all');
  const [cardsData, setCardsData] = useState({});
  const [products, setProducts] = useState({});

  useEffect(() => {
    if (hasAccess) {
      getInfoCardsData({}).then(response => {
        const reportData = response?.data?.first?.dataset
          ? response.data
          : (response?.first?.dataset ? response : null);

        if (!reportData) {
          if (hideSpinner) {
            hideSpinner();
          }
          return;
        }

        setCardsData(reportData);
      });
    }

    return () => {
      store.dispatch(hideNotification());
    };
  }, [hasAccess, hideSpinner]);

  const handleOnBarExpand = () => {
    setExpandChart(expandChart === 'bar' ? 'all' : 'bar');
  };

  const handleOnLineExpand = () => {
    setExpandChart(expandChart === 'line' ? 'all' : 'line');
  };

  const setProductGroupsID = productGroups => {
    if (Object.keys(productGroups).length !== 0) {
      setProducts(productGroups);
    }
  };

  return (
    <DashboardLayout pageTitle={<FormattedMessage id="app.dashboard.page_title"/>} workspace {...props}>
      <PageWorkspace className="general-reports-workspace">
        <PageHeader title={<FormattedMessage id="navigation.reports.general"/>}/>
        {hasAccess ? (
          <Container fluid>
            <div className="header-body">
              <Row>
                <ChartHeaders cardsData={cardsData} products={products}/>
              </Row>
            </div>
            <Row>
              <Col
                md="12"
                xl="12"
                style={{ display: expandChart === 'line' ? 'none' : 'block' }}
              >
                <FinancialBar
                  title={<FormattedMessage id="components.pages.reports.financial"/>}
                  subtitle={<FormattedMessage id="components.pages.reports.period"/>}
                  options={chartExample2.options}
                  id="chart-sales"
                  className="chart-canvas"
                  expandButton={(
                    <Button className="btn btn-fullscreen" onClick={handleOnBarExpand}>
                      <i className="fas fa-expand"> </i>
                    </Button>
                  )}
                  expandClassName={expandChart === 'bar' ? 'chart custom-expand' : 'chart'}
                  setProductGroupsID={setProductGroupsID}
                />
              </Col>
              <Col
                md="12"
                xl="12"
                style={{ display: expandChart === 'bar' ? 'none' : 'block' }}
              >
                <QualitativeLine
                  title="KPI"
                  subtitle={<FormattedMessage id="components.pages.reports.period"/>}
                  options={chartExample3.options}
                  id="chart-sales"
                  className="chart-canvas"
                  expandButton={(
                    <Button className="btn btn-fullscreen" onClick={handleOnLineExpand}>
                      <i className="fa fa-expand"> </i>
                    </Button>
                  )}
                  expandClassName={expandChart === 'line' ? 'chart custom-expand' : 'chart'}
                />
              </Col>
            </Row>
          </Container>
        ) : (
          <PageSurface className="general-reports-no-rights-surface">
            <Messages/>
            <NoRights/>
          </PageSurface>
        )}
      </PageWorkspace>
    </DashboardLayout>
  );
};

export { GeneralReports };
